var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "awaiting-message-details",
        title: _vm.$t("message.historyDetails"),
        "show-footer": false,
      },
      on: { cancel: _vm.closeModal },
    },
    [
      _c(
        "b-tabs",
        { attrs: { "content-class": "mt-3", id: "ticket-response" } },
        [
          _c(
            "b-tab",
            { attrs: { title: _vm.$t("message.chat"), active: "" } },
            [
              _vm.selectedHistory.type === "osr"
                ? _c(
                    "div",
                    [
                      _c("p", { staticClass: "p-2" }, [
                        _vm._v(_vm._s(_vm.selectedHistory.messages)),
                      ]),
                      _vm._v(" "),
                      _c("quill-editor", {
                        attrs: { options: _vm.editorOption },
                        model: {
                          value: _vm.responseText,
                          callback: function ($$v) {
                            _vm.responseText = $$v
                          },
                          expression: "responseText",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { defaultValue: null },
                          model: {
                            value: _vm.selectedSenderMailId,
                            callback: function ($$v) {
                              _vm.selectedSenderMailId = $$v
                            },
                            expression: "selectedSenderMailId",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { selected: true, value: "null" } },
                            [_vm._v("👉Select Email Sender...")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.senderMails, function (senderMail) {
                            return _c(
                              "a-select-option",
                              {
                                key: senderMail.mail,
                                attrs: { value: senderMail._id },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(senderMail.mail) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.isSupsisMail()
                                ? _c("div", { staticClass: "mail-warning" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!"
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.replace(
                                              "/integrations/mail"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Mail adresi eklemek için tıklayınız\n                            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "float-right",
                                  attrs: { ghost: "" },
                                  on: { click: _vm.closeModal },
                                },
                                [
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.cancel")) +
                                        "\n                            "
                                    ),
                                  ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "float-right mr-2",
                                  attrs: {
                                    primary: "",
                                    disabled: _vm.responseSending,
                                  },
                                  on: { click: _vm.sendResponse },
                                },
                                [
                                  !_vm.responseSending
                                    ? [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("message.send")) +
                                            "\n                            "
                                        ),
                                      ]
                                    : [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                            "
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _vm.filteredMessages.length
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _vm.filteredMessages.length
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "chat-scroll",
                                        rawName: "v-chat-scroll",
                                      },
                                    ],
                                    staticClass: "waiting-ticket-messages",
                                  },
                                  [
                                    _c("MessageList", {
                                      attrs: {
                                        contextMenuVisable: false,
                                        "always-scroll-to-bottom": false,
                                        colors: _vm.colors,
                                        messages: _vm.getMessages(),
                                        participants: _vm.getParticipants(),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("quill-editor", {
                              attrs: { options: _vm.editorOption },
                              model: {
                                value: _vm.responseText,
                                callback: function ($$v) {
                                  _vm.responseText = $$v
                                },
                                expression: "responseText",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                attrs: { defaultValue: null },
                                model: {
                                  value: _vm.selectedSenderMailId,
                                  callback: function ($$v) {
                                    _vm.selectedSenderMailId = $$v
                                  },
                                  expression: "selectedSenderMailId",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { selected: true, value: "null" } },
                                  [_vm._v("👉Select Email Sender...")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.senderMails, function (senderMail) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: senderMail.mail,
                                      attrs: { value: senderMail._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(senderMail.mail) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                ["instagram-comment"].includes(_vm.ticket.type)
                                  ? _c("a-switch", {
                                      attrs: {
                                        name: "hidden",
                                        "checked-children": "Hidden Comment",
                                        "un-checked-children":
                                          "Unhidden Comment",
                                      },
                                      model: {
                                        value: _vm.hidden,
                                        callback: function ($$v) {
                                          _vm.hidden = $$v
                                        },
                                        expression: "hidden",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { ghost: "" },
                                    on: { click: _vm.closeModal },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.cancel")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                ![
                                  "instagram-comment",
                                  "instagram-mention",
                                  "page-comment",
                                ].includes(_vm.ticket.type)
                                  ? _c(
                                      "SupsisButton",
                                      {
                                        attrs: {
                                          primary: "",
                                          disabled: _vm.responseSending,
                                        },
                                        on: { click: _vm.sendResponse },
                                      },
                                      [
                                        _vm.responseSending
                                          ? _c(
                                              "span",
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t("message.sending")
                                                    ) +
                                                    "...\n                            "
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.send"))
                                              ),
                                            ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                ["instagram-comment"].includes(_vm.ticket.type)
                                  ? _c(
                                      "SupsisButton",
                                      {
                                        attrs: {
                                          danger: "",
                                          disabled: _vm.responseSending,
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.deleteComment()
                                          },
                                        },
                                      },
                                      [
                                        _vm.responseSending
                                          ? _c(
                                              "span",
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                Deleting...\n                            "
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                "Delete Comment and Close"
                                              ),
                                            ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                [
                                  "instagram-comment",
                                  "instagram-mention",
                                  "page-comment",
                                ].includes(_vm.ticket.type)
                                  ? _c(
                                      "SupsisButton",
                                      {
                                        attrs: {
                                          primary: "",
                                          disabled: _vm.responseSending,
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.sendAsComment(false)
                                          },
                                        },
                                      },
                                      [
                                        _vm.responseSending
                                          ? _c(
                                              "span",
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t("message.sending")
                                                    ) +
                                                    "...\n                            "
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.replyAsAComment"
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                ["instagram-comment", "page-comment"].includes(
                                  _vm.ticket.type
                                )
                                  ? _c(
                                      "SupsisButton",
                                      {
                                        attrs: {
                                          primary: "",
                                          disabled: _vm.responseSending,
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.sendAsComment(true)
                                          },
                                        },
                                      },
                                      [
                                        _vm.responseSending
                                          ? _c(
                                              "span",
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t("message.sending")
                                                    ) +
                                                    "...\n                            "
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.ReplyAsAPm")
                                                )
                                              ),
                                            ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "b-alert",
                              { attrs: { show: "", variant: "info" } },
                              [_vm._v(_vm._s(_vm.$t("message.chatNotFound")))]
                            ),
                          ],
                          1
                        ),
                  ]),
            ]
          ),
          _vm._v(" "),
          !!_vm.isVisitorExist()
            ? _c("b-tab", { attrs: { title: _vm.$t("message.visitorInfo") } }, [
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.fullName")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.visitorInfo.fullname) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.email")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.visitorInfo.email) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.phone")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.visitorInfo.phone) +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [_vm._v("IP")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.ticket.visitor.ipAddress || "-") +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.browser")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.ticket.visitor.browser || "-") +
                        "\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(_vm._s(_vm.$t("message.os"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.ticket.visitor.os || "-") +
                        "\n                "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }